<template>
  <div class="p-4">
    <div class="flex gap-3 items-start">
      <InputField
        v-model="hours"
        title="Hours"
        class="w-20"
        :validation="firstErrorMessage(v$.hours) ? 'error' : ''"
        :helper-text="firstErrorMessage(v$.hours)"
      />
      <InputField
        v-model="minutes"
        title="Min"
        class="w-20"
        :validation="firstErrorMessage(v$.minutes) ? 'error' : ''"
        :helper-text="firstErrorMessage(v$.minutes)"
      />
    </div>
    <Button label="Save" class="w-full" @click="handleSave" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useStore } from "vuex";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Button from "@/components/Seranova/Buttons/Button.vue";
import InputField from "@/components/Seranova/InputField/InputField.vue";
import { AppointmentV2 } from "@/typings/appointment";
import useVuelidate from "@vuelidate/core";
import {
  helpers,
  maxValue,
  numeric,
  requiredUnless
} from "@vuelidate/validators";

const emit = defineEmits(["saved"]);
const props = defineProps<{ appointment: AppointmentV2 }>();
const store = useStore();
const hours = ref("");
const minutes = ref("");

const handleSave = async () => {
  const valid = await v$.value.$validate();
  if (!valid) return;
  const duration =
    parseInt(hours.value || "0") * 60 + parseInt(minutes.value || "0");
  await store.dispatch("updateAppointmentEventDuration", {
    appointmentId: props.appointment.id,
    duration_minutes: duration
  });
  window.notify.success("Appointment duration updated");
  emit("saved");
  tippy.hideAll();
};

const v$ = useVuelidate(
  {
    hours: {
      numeric: helpers.withMessage("Invalid value", numeric),
      max: helpers.withMessage("Invalid value", maxValue(24)),
      requiredIf: requiredUnless(minutes)
    },
    minutes: {
      numeric: helpers.withMessage("Invalid value", numeric),
      max: helpers.withMessage("Invalid value", maxValue(60)),
      requiredIf: requiredUnless(hours)
    }
  },
  {
    hours,
    minutes
  }
);
</script>

<style scoped></style>
